import { render } from "./DocumentPanel.vue?vue&type=template&id=f8b8e7d6&scoped=true"
import script from "./DocumentPanel.vue?vue&type=script&lang=js"
export * from "./DocumentPanel.vue?vue&type=script&lang=js"

import "./DocumentPanel.vue?vue&type=style&index=0&id=f8b8e7d6&lang=scss&scoped=true"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8b8e7d6"]])

export default __exports__